const columns: { id: number; title: string; links: { id: number; label: string; href: string }[] }[] = [
  {
    id: 1,
    title: "内容归档",
    links: [
      { id: 1, label: "直播口播事故", href: "#categories" },
      { id: 2, label: "虚假宣称", href: "#categories" },
      { id: 3, label: "数据注水", href: "#categories" },
      { id: 4, label: "账号封禁", href: "#categories" },
    ],
  },
  {
    id: 2,
    title: "社区",
    links: [
      { id: 1, label: "最新讨论", href: "#community" },
      { id: 2, label: "线索上报", href: "#community" },
      { id: 3, label: "达人名录", href: "#directory" },
      { id: 4, label: "讨论热度榜", href: "#ranking" },
    ],
  },
  {
    id: 3,
    title: "关于",
    links: [
      { id: 1, label: "事件时间线", href: "#timeline" },
      { id: 2, label: "客户端下载", href: "#download" },
      { id: 3, label: "更新说明", href: "#feed" },
      { id: 4, label: "内容规范", href: "#top" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">黑料国产</span>
            </div>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-background-300 md:text-sm">
              把国产网红、主播、博主的公开事件按时间线归档，也留一个地方让大家把看到的细节说清楚。看得见的现场，才经得起反复翻。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-white/15 text-background-200 transition-colors hover:border-accent-400/60 hover:text-accent-300"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.id} className="md:col-span-2">
              <h3 className="text-sm font-bold text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-xs text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[11px] leading-relaxed text-background-300">
            本站为演示站点，页面内所有人物、账号与事件均为虚构内容，不指向任何真实个人或机构。
          </p>
          <p className="text-[11px] text-background-400">© 2026 黑料国产 · 事件档案站</p>
        </div>
      </div>
    </footer>
  );
}